import { SKILLS } from "../data/constants";

export default function Skills() {
  return (
    <section id="skills" className="sec">
      <p className="sec-marker reveal">{"// my tech stack"}</p>

      <h2 className="h2 reveal d1" style={{ marginBottom: 34 }}>
        Tools I reach<br /><span className="ghost">for first.</span>
      </h2>

      {/* Reads as a config file: key on the left, values as tokens on the right */}
      <div className="reveal d2">
        <p style={{ fontSize: 11.5, color: "var(--fg-mute)", marginBottom: 6 }}>
          <span className="t-key">export default</span> <span className="t-fn">stack</span> = {"{"}
        </p>

        <div style={{ paddingLeft: 18 }}>
          {Object.entries(SKILLS).map(([group, items]) => (
            <div className="skill-row" key={group}>
              <span className="skill-key">{group}:</span>
              <span className="skill-vals">
                {items.map((item) => <span className="chip" key={item}>{item}</span>)}
              </span>
            </div>
          ))}
        </div>

        <p style={{ fontSize: 11.5, color: "var(--fg-mute)", marginTop: 10 }}>{"}"}</p>
      </div>
    </section>
  );
}
